module.exports = __webpack_public_path__ + "img/burro.189be58f.svg";